module.exports = __webpack_public_path__ + "media/bootstrap-icons/plus-circle-8219460c.svg";